import { createSelector } from 'reselect'

export const getNotifications = createSelector(
  (state) => state && state.user && state.user.profile && state.user.profile.notifications &&
  Array.isArray(state.user.profile.notifications)
    ? state.user.profile.notifications
    : [],
  notifications => notifications
)
